<template>

	<!-- Contents-->
	<div class="container">

		<edu-learning v-if="mode === 'learn' && emIdx > 0" @goList="goList"></edu-learning>


		<div class="content" v-if="mode === '' || mode === 'list' ">
			<h2 class="tit_page">{{ titleCodeVO.codeName }}</h2>


			<!-- 탭 -->
			<div class="board_category swiper-container">
				<ul class="swiper-wrapper">
					<li class="swiper-slide">
						<router-link tag="button" :to="'/app/education/course/' + $route.params.cateCode">교육과정</router-link>
					</li>
					<li class="active swiper-slide">
						<router-link tag="button" :to="'/app/education/main/' + $route.params.cateCode">교육과목</router-link>
					</li>
				</ul>
			</div>


			<code-selector @selectCode="setCateCode" :code="$route.params.cateCode" field="cateCode" ></code-selector>


			<form @submit.prevent="doSearch">
				<div class="board_search">
					<!--<div class="select_box">
						<select name="" class="slt">
							<option value="">전체</option>
							<option value="">제목</option>
							<option value="">내용</option>
							<option value="">작성자</option>
						</select>
					</div>-->
					<div class="input_box">
						<input type="text" name="" class="inp" placeholder="내용을 입력해 주세요." v-model="params.searchText">
						<button type="submit"><img src="/ssflex_cs1/assets/img/common/ico/ico_search.svg" alt="검색"></button>
					</div>
				</div>
			</form>


			<div class="board_sort">
				<div class="total_box">총 <b>{{ eduCount }}</b>건</div>

				<edu-sorter @doSort="doSort"></edu-sorter>
			</div>


			<edu-list :edu-list="eduList"></edu-list>


			<div class="board_more" v-if="eduList.length < eduCount">
				<button type="button" class="btn_more" @click="doLoadMore"><img src="/ssflex_cs1/assets/img/common/ico/ico_down_w.svg" alt=""></button>
			</div>
		</div>
	</div>

</template>

<script>
import $ from 'jquery'
import EduList from "@/cs1/components/educations/main/eduList";
import EduLearning from "@/cs1/components/educations/main/eduLearning";
import CodeSelector from "@/cs1/components/selectors/codeSelector";
import EduSorter from "@/cs1/components/educations/eduSorter";

export default {
	name: "appEducations",
	components: {EduSorter, CodeSelector, EduLearning, EduList},
	props: {
		cateCode: String,
		cateName: String,
	},
	data() {

		/**
		 * mode : list, learn
		 * @type {string|string}
		 */
		var mode = this.webUtils.getParameter("mode")
		mode = (mode === '') ? "list" : mode;

		/**
		 * emIdx
		 * @type {number|string|string}
		 */
		var emIdx = this.webUtils.getParameterInt("emIdx");
		emIdx = ( emIdx > 0 ) ? emIdx : 0;

		var params = new this.pageUtils.Params();
		params.size = 8;

		/**
		 * cateCode : params 우선, query 후순위
		 */
		if ( !this.stringUtils.isEmpty( this.$route.params.cateCode ) ) {
			params.cateCode = this.$route.params.cateCode
		} else {
			params.cateCode = this.$route.query.cateCode
		}

		if ( this.stringUtils.isEmpty(params.cateCode) ) {
			params.cateCode = "2001"
		}

		return {
			mode,
			emIdx,
			cateCodeVO: {},
			coAccountVO: {},
			titleCodeVO: {},

			params,

			eduList: [],
			eduCount: 0,
			rateCode: 0,
		}
	},
	beforeCreate() {
		if (location.hash) {
			let hash = location.hash.replace("#", "")

			this.webUtils.scroll(this, '#item-' + hash)
		}
	},
	created() {
		this.$eventBus.$on("goLearning", (_emIdx) => {
			this.goLearning( _emIdx );
		});

		if (location.hash) {
			let hash = location.hash.replace("#", "")
			if (hash !== 'loadMore') {
				this.webUtils.scroll(this, '#item-' + hash)
			}
		}
	},
	async mounted() {

		this.titleCodeVO = await this.getCodeOne( this.params.cateCode )

		this.getMainList();

		$(".list-controls .tab").each(function () {
			var tabnav = new Swiper($(this), {
				slidesPerView: "auto",
				spaceBetween: 24,
				freeMode: true,
				breakpoints: {
					767: {
						spaceBetween: 16,
					},
				},
			});
		});

	},
	methods: {


		getMainList () {
			this.coAccountVO = this.getSessionProc();

			var temp = this.params
			if ( !this.stringUtils.isEmpty( this.$route.query.cateCode ) ) {
				temp.cateCode = this.$route.query.cateCode;
			}

			this.$eventBus.$emit("startProgress", 1)
			this.axiosCaller.get( this, this.APIs.EDU_MAIN + "/", temp, (res) => {
				this.$eventBus.$emit("doneProgress", 1)

				const result = res.data
				if ( result.status === "ok" ) {

					console.log( result )
					// this.eduList.push(...result.list)
					this.eduList = result.list
					this.eduCount = result.count

					if (location.hash) {
						let hash = location.hash.replace("#", "")
						if (hash === 'loadMore') {
							this.webUtils.scroll(
								this
								, '#item-' + this.eduList[(this.params.size) * (this.params.page * 1) - 1].emIdx
								, {
									behavior: "smooth"
									, block: "center"
								}
								, () => this.webUtils.removeHash()
								, () => {
									document.querySelector('.learning').scrollIntoView({
										behavior: "smooth"
										, block: "end"
									})
									this.webUtils.removeHash()
								}
								, 1000
							)
						}
					}
				} else {
					console.log( result.msg )
				}

			})

		},


		doLoadMore() {

			this.params.page++;
			this.params.hash = 'loadMore'

			this.webUtils.goTo(this, this.params)
			// this.pageUtils.routerPush2( this, this.params, () => {
			// 	this.getMainList();
			// } )
			// this.getMainList();
		},


		setCateCode( _cateCode ) {

			// 빈코드가 올 경우 기본 코드 전송
			if ( _cateCode == null || _cateCode === "" ) {
				_cateCode = this.cateCode
			}

			this.params.page = 0
			this.params.cateCode = _cateCode;
			this.params.searchText = "";

			this.pageUtils.routerPush( this, this.params )
			// this.getMainList();
		},


		doSearch(e) {

			e.preventDefault()

			this.params.page = 0
			//this.params.cateCode = "";

			this.pageUtils.routerPush( this, this.params )
			// this.getMainList();
		},



		doSort ( _sort ) {
			this.params.sort = _sort;
			this.pageUtils.routerPush( this, this.params )
			// this.getMainList();
		},



		goLearning(_emIdx) {

			this.mode = "learn"
			this.emIdx = _emIdx
			var temp = {
				mode: this.mode,
				emIdx: _emIdx,
				page: this.params.page,
				sort: this.params.sort,
				searchText: this.params.searchText
			}
			this.webUtils.goTo(this, temp, true, false, () => {
				this.webUtils.scrollTo('.content');
			})
		},

		goList() {
			this.webUtils.goTo(this, { page: this.params.page, sort: this.params.sort, searchText: this.params.searchText, hash: this.webUtils.getParameter("emIdx") })
		}


	},
}
</script>

<style scoped>

</style>
